import { render, staticRenderFns } from "./MedicalReasonPage.vue?vue&type=template&id=23b47992&"
import script from "./MedicalReasonPage.vue?vue&type=script&lang=js&"
export * from "./MedicalReasonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports